import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { IdentityMgtComponent } from 'src/app/identity-mgt/identity-mgt.component';
import { Router } from '@angular/router';
import { ForgotService } from 'src/app/shared/Forgot.Service';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-advisor-pass',
  templateUrl: './advisor-pass.component.html',
  styleUrls: ['./advisor-pass.component.scss']
})
export class AdvisorPassComponent implements OnInit {

  public type: string;
  public show = false;
  @Input() userid = '';
  @Input() govid = '';
  public pasteData = '';
  public pasteInd = 'N';
  forgot: any;
  error: boolean;
  message: any;
  public showPlaceholder: boolean;
  public isLoading = false;
  public validate = true;
  public errorFields: any = {
    govid: false,
    userid: false
  };


  constructor(private forgotService: ForgotService, private router: Router,private httpclient: HttpClient,) { }

  @ViewChild('user') public user: ElementRef;
  @ViewChild('ssn') public ssn: ElementRef;

  ngOnInit() {
    window.scroll(0,0);
    this.showPlaceholder = true;
    this.type = 'password'; // display as '*'
  }
  
  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute('placeholder', ele.getAttribute('data-placeholder'));
    } else {
      ele.setAttribute('placeholder', '');
    }
  }
  
  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }
  
  numberOnly(event) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      return event.preventDefault();
    }
    return true;
  }
  
  focusOnInput() {
    let setError = false;
    if (!!this.errorFields.govid || !!this.errorFields.govidVal) {
      setError = true;
      setTimeout(() => this.ssn.nativeElement.focus(), 0);
      setTimeout(() => this.ssn.nativeElement.select(), 0);
      window.scrollTo(0,this.ssn.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.errorFields.userid) {
      setError = true;
      setTimeout(() => this.user.nativeElement.focus(), 0);
      setTimeout(() => this.user.nativeElement.select(), 0);
      window.scrollTo(0,this.user.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    }
    return setError;
  }

  isErrorPresent() {
    if (!this.errorFields.govid && this.errorFields.govidVal && !this.errorFields.userid) {
      return false;
    } else {
      return true;
    }
  }

  validateAllFields() {
    const fields = ['govid', 'userid'];
    let isErrPresent = false;
    for (let j = 0; j < fields.length; j++) {
      isErrPresent = this.validateFields(fields[j]);
      if (isErrPresent) {
        break;
      }
    }
    return isErrPresent;
  }

  ifAtleastOneFieldValidated(model) {
    this.validate = !!this[model] ? false : true;
    return this.validate;
  }
  
  validateFields(model) {
    let error = false;
    this.validate = true;
    if (model === 'govid') {
      if (!this.govid) {
        this.errorFields.govid = true;
        this.errorFields.govidVal = false;
        error = true;
      } else if (this.govid !== '' && this.govid.length < 4) {
        this.errorFields.govid = false;
        this.errorFields.govidVal = true;
        error = true;
      } else {
        this.errorFields.govid = false;
        this.errorFields.govidVal = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }
   if (model === 'userid') {
    if (!this.userid) {
      this.errorFields.userid = true;
      error = true;
    } else {
      this.errorFields.userid = false;
      this.ifAtleastOneFieldValidated(model);
    }
   }

    if (!!this.govid && !!this.userid && !this.isErrorPresent() && !error) {
      this.validate = error;
    }
    return error;
  }
  
  
  toggleShow() {
    this.show = !this.show;
    if (this.show) {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }

  continue() {
	 if (!this.validateAllFields()) {
	 	if (this.pasteData === this.govid) {
	      this.pasteInd = 'Y';
	    } else {
	      this.pasteInd = 'N';
	    }
	    const userId = this.userid;
	    const userType = 'advisor';
	    const ssn = this.govid;
	    const pasted = this.pasteInd;
	    const bodyString = JSON.stringify({ userId, ssn, userType, pasted });
	    setTimeout(() => {
	        window.scrollTo(0, 0);
	        this.error = false;
	        this.isLoading = true;
	        this.validate = true;
	    });
	      this.forgotService.getPassword(bodyString).subscribe(res => {
	        this.forgot = res;
	        if (this.forgot) {	          
	          if (this.forgot.status_code && this.forgot.status_code === '200') {
	            let url = false;
	            let question = false;
	            // if (this.forgot.url && !question) {
	            //   url = true;
	            //   console.log('url in advisor ' + this.forgot.url);
	            //   window.location.href = this.forgot.url;
	            // }
	
	            if (this.forgot.questions && !url) {
	              question = true;
	              this.forgotService.setQuestions(this.forgot.questions);
	              this.forgotService.setUserType('advisor');
                console.log(' else url in advisor ' + this.forgot.url);
                if(this.forgot.url) {
                  window.location.href = window.location.origin + this.forgot.url;
                  console.log("window.location.href + " + window.location.href)
                } else {
                  this.router.navigate(['/questions']);
                }
	            }
	          } else {
	            setTimeout(() => {
	              this.isLoading = false;
	            });
	            this.message = this.forgot.message;
	            this.error = true;
	            this.validate = false;
	            window.scroll(0,0);
	          }
	        }
	      });	 	
	 } else {
	 	this.focusOnInput();
	 }
  }

  paste(event: ClipboardEvent) {
    if (event && event.clipboardData) {
      this.pasteData = event.clipboardData.getData('text');
    }
  }

  cancel() {
    this.router.navigate(['']);
  }
}
